import styled from "@emotion/styled";
import { OLD_BLUE } from "src/constants/colors";

export const SelectionIndicator = styled.div<{ isSelected: boolean }>`
  border: 1.5px solid rgba(104, 112, 131, 1);
  border-radius: 50%;
  height: 14px;
  width: 14px;

  ${({ isSelected }) =>
    isSelected &&
    `
    background-color: ${OLD_BLUE};
    border-color: ${OLD_BLUE};
  `}
`;
